const paymentType = 'mollie:componentset';

const getConfig = (root, kind = 'config') => {
	const selector = `script[data-kind="${kind}"][type="application/json"]`;
	return [...root.querySelectorAll(selector)].map((script) => JSON.parse(script.textContent));
}

Alpine.data('SevenMollieCreditCard', (element) => ({
	config: getConfig(element).at(-1),
	fieldNames: ['cardHolder', 'cardNumber', 'expiryDate', 'verificationCode'],

	init() {
		this.initSDK();
	},

	initSDK() {
		const script = document.createElement('script');
		script.src = 'https://js.mollie.com/v1/mollie.js';
		document.head.appendChild(script); // You can also use document.body.appendChild(script);
		script.onload = () => this.sdkReady();
	},

	sdkReady() {
		this.mollie = Mollie(this.config.profileId, {
			locale: this.config.locale,
			testmode: window.location.origin.includes('ddev.site')
		});

		this._mountFields();
		const tokenType = `${paymentType}:creditcard`;

		this._dispatchEvent('init', {
			tokenType,
			id: this.config.id,
			instance: this.mollie,
			tokenize: async () => {
				const {token} = await this.mollie.createToken();

				return {
					// details: token.details,
					paymentToken: {
						...(token ? {nonce: token} : {}),
						type: tokenType,
					},
				}
			},
			validate: () => {},
		});
	},
	_mountFields() {
		this.fieldNames.forEach((fieldName) => {
			const component = this.mollie.createComponent(fieldName);
			component.mount(`#${fieldName}`);

			const error = document.getElementById(`${fieldName}-error`);

			component.addEventListener('change', event => {
				if (event.error && event.touched) {
					error.textContent = event.error;
				} else {
					error.textContent = '';
				}
			});
		});
	},

	_dispatchEvent(name, {cancelable, bubbles, ...detail} = {}) {
		return element.dispatchEvent(new CustomEvent(`seven:mollie:componentset:${name}`, {
			detail,
			bubbles: bubbles ?? true,
			cancelable: cancelable ?? true,
		}));
	}
}));
